goog.provide("shadow.js.shim.module$src$svg$objects$automagic_svg$default");
shadow.js.shim.module$src$svg$objects$automagic_svg$default = shadow.js.shim.module$src$svg$objects$automagic_svg.default;
